export default __webpack_public_path__ + "faces.3e7024.png";